import type { MouseEvent } from 'react'

// Portal links are anchors, not buttons: these are real URLs on a
// partner-facing site, and opening two pages side by side is ordinary. A button
// gives up cmd-click, middle-click, "open in new tab", and "copy link address"
// for nothing. SPA routing survives — the modifier keys are left to the
// browser, and only a plain left click is intercepted. A real href also means
// the service's reserved-prefix fallback gets exercised by ordinary
// link-following.
export const isPlainClick = (event: MouseEvent<HTMLAnchorElement>): boolean =>
  !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey

/** Click handler that routes a plain click through the SPA and leaves every
 * modified click to the browser. */
export const navigateOnPlainClick =
  (onNavigate: (path: string) => void, path: string) =>
  (event: MouseEvent<HTMLAnchorElement>) => {
    if (!isPlainClick(event)) return
    event.preventDefault()
    onNavigate(path)
  }
